// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ca12069","879":"793a27f4"}[chunkId] + ".chunk.js";
};